import { render, staticRenderFns } from "./SupplierRawMaterialCompanyData.vue?vue&type=template&id=51ae5c94&scoped=true&"
import script from "./SupplierRawMaterialCompanyData.vue?vue&type=script&lang=js&"
export * from "./SupplierRawMaterialCompanyData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ae5c94",
  null
  
)

export default component.exports